// Version : 0.0.1
// Author : SATHISH
// LastEdit : SATHISH
// MODFIED DATE:19-09-2025
//Last ADD :CODE REVIEW CHANGES AND ADD VERSION
import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/*************** START ADD PRODUCT TYPE DETAILS ******************/
export const productTypeDetailsAdd = (addData: any) => {
	const data = {
		AddProductTypeDetailsToken: addData,
	};
	const url = `${API_URL}addProductTypeDetails`;
	return makeApiCall(url, data);
};
/*************** END ADD PRODUCT TYPE DETAILS ******************/

/*************** START UPDATE PRODUCT TYPE DETAILS ******************/
export const productTypeDetailsUpdate = (updateData: any) => {
	const data = {
		UpdateProductTypeDetailsToken: updateData,
	};
	const url = `${API_URL}updateProductTypeDetails`;
	return makeApiCall(url, data);
};
/*************** END UPDATE PRODUCT TYPE DETAILS ******************/

/*************** START GET PRODUCT TYPE LIST ******************/
export const productTypeListGet = (listData: any) => {
	const data = {
		GetProductTypeListToken: listData,
	};
	const url = `${API_URL}getProductTypeList`;
	return makeApiCall(url, data);
};
/*************** END GET PRODUCT TYPE LIST ******************/

/*************** START FETCH PRODUCT TYPE DETAILS ******************/
export const productTypeDetailsFetch = (fetchData: any) => {
	const data = {
		FetchProductTypeDetailsToken: fetchData,
	};
	const url = `${API_URL}fetchProductTypeDetails`;
	return makeApiCall(url, data);
};
/*************** END FETCH PRODUCT TYPE DETAILS ******************/

/*************** START DELETE PRODUCT TYPE DETAILS ******************/
export const productTypeDetailsDelete = (deleteData: any) => {
	const data = {
		DeleteProductTypeDetailsToken: deleteData,
	};
	const url = `${API_URL}deleteProductTypeDetails`;
	return makeApiCall(url, data);
};
/*************** END DELETE PRODUCT TYPE DETAILS ******************/
